import { ErrorResponse, UpdateAddressInfo } from 'types/form';
import { ICurrentAddressInfo } from '@components/TwoYearsAddressHistoryForm/TwoYearsAddressHistoryForm';
import { monthsBetween } from 'utils/dateUtils';
import {
  ApiResources,
  createErrorResponse,
  formatPostalCode,
  getRequestHeaders,
  getUrl,
  Methods,
  processResponse,
} from './utils';

export interface IAddressHistoryResponse {
  contactId: string;
  leadId: string;
  success: true;
  message: string;
}

const mapAddressToCreateAddressHistory = (addresses: ICurrentAddressInfo[]): UpdateAddressInfo[] => {
  return addresses.map((address, index) => {
    return {
      isCurrent: index === 0, //First address in the array is the current address
      monthsAtAddress: address?.moveOutDate !== '' ? monthsBetween(address?.moveInDate, address?.moveOutDate) : 0,
      streetLine1: address.streetLine1,
      streetLine2: address.streetLine2,
      city: address.city,
      state: address.state,
      zip: formatPostalCode(address.zip),
      type: address.type !== '' ? address.type : 'NotSet',
      county: '',
      monthlyPayment: address.monthlyPayment,
    };
  });
};

export const createAddressHistory = async (
  addressHistoryPayload: ICurrentAddressInfo[],
  contactId: string
): Promise<IAddressHistoryResponse | ErrorResponse> => {
  const requestPayload = mapAddressToCreateAddressHistory(addressHistoryPayload);

  const endpoint = `${getUrl(ApiResources.getContactByContactId)}/${contactId}/address`;
  const request = {
    method: Methods.patch,
    headers: await getRequestHeaders(),
    body: JSON.stringify(requestPayload),
  };
  try {
    const response = await fetch(endpoint, request);
    return processResponse(response);
  } catch (error) {
    return createErrorResponse(error instanceof Error ? error.name : 400, error instanceof Error ? error.message : '');
  }
};
